<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ReviewContractForm />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ReviewContractForm from '@/components/admin/ReviewContractForm.vue'

export default {
  name: 'apply-contract',
  props: ['message'],
  components: {
    Nav,
    ReviewContractForm
  }
}
</script>